import { PurchaseHistoryData } from '@/features/games/shared/types/purchase-history.types';
import { getRentalExpiration } from '@/features/games/shared/helpers/get-rental-expiration';

export const isAlreadyRented = (
  productKey: string,
  purchaseHistory: PurchaseHistoryData | null,
): boolean => {
  if (!purchaseHistory) return false;
  const expireDate = getRentalExpiration(purchaseHistory.rentals, productKey);
  return !!expireDate && expireDate > Date.now();
};
